"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class DigSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.DIG);
        this.isReady = false;
        this.holes = [];
        this.possibleCollidersPreventingHole = [];
        this.playerHasShovelEquipped = false;
        this.initializingFromGameState = false;
        this.digCooldown = 0;
        this._isShoveling = false;
        this.playerHoleCollisionPlugin = {
            type: 'collision',
            name: 'holes',
            tagAs: [Constants_1.COLLIDER_TAGS.in_front_of_client_player],
            tagBs: [Constants_1.COLLIDER_TAGS.hole],
            onCollisionStart: (colA, colB) => {
                if (!this.focusedHole) {
                    this.focusedHole = colB.gameObject;
                }
            },
            onCollision: (colA, colB) => {
                if (!this.focusedHole) {
                    this.focusedHole = colB.gameObject;
                }
            },
            onCollisionEnd: (colA, colB) => {
                if (this.focusedHole === colB.gameObject) {
                    this.focusedHole = null;
                }
            },
        };
        this.playerPreventHoleCollisionPlugin = {
            type: 'collision',
            name: 'prevent_holes',
            tagAs: [Constants_1.COLLIDER_TAGS.in_front_of_client_player],
            tagBs: [Constants_1.COLLIDER_TAGS.prevent_hole, Constants_1.COLLIDER_TAGS.blocking, Constants_1.COLLIDER_TAGS.water],
            onCollisionStart: (colA, colB) => {
                this.possibleCollidersPreventingHole.push(colB);
            },
            onCollision: (colA, colB) => {
                this.possibleCollidersPreventingHole.push(colB);
            },
        };
    }
    onClear() {
    }
    shovelIsEquipped() {
        return this.playerHasShovelEquipped;
    }
    handleInitPlayer() {
        this.playerInput = this.globals.clientPlayer.playerInput;
        this.playerAction = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ACTION);
        this.playerAnimation = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION);
        const skel = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION).skeleton;
        const regAniListeners = (_skel) => {
            _skel.onStart((actionName, track) => {
                if (!track === _skel.baseTrack)
                    return;
                if (actionName === 'dig' && this.playerHasShovelEquipped) {
                    this._isShoveling = true;
                }
                else {
                    this._isShoveling = false;
                }
            });
            _skel.onEnd((actionName, track) => {
                if (!track === _skel.baseTrack)
                    return;
                if (actionName === 'dig' && this.playerHasShovelEquipped) {
                    this._isShoveling = false;
                }
            });
        };
        !skel ? this.globals.clientPlayer.once('skeleton-ready', regAniListeners) : regAniListeners(skel);
        this.globals.clientPlayer._has;
    }
    initHoleGameObject(uid, x, y) {
        //console.error('hole texture was', this.holeTexture)
        return this.globals.tileWorld.addGameObject({
            texture: this.holeTexture,
            position: { x, y },
            layer: 1,
            colliders: [{
                    layer: 1,
                    dynamic: false,
                    shapeData: { x: 0, y: 0, w: this.holeTexture.width, h: this.holeTexture.height },
                    tags: [Constants_1.COLLIDER_TAGS.hole, Constants_1.COLLIDER_TAGS.prevent_hole],
                    data: {
                        sortOffsetTop: -10,
                    }
                }],
            data: {
                uid,
            }
        });
    }
    onStart() {
        this.globals.tileWorld.onBeforeMapDestroyed(mapName => {
            if (mapName === 'island') {
                if (this.focusedHole) {
                    this.focusedHole = null;
                }
                this.holes.forEach(({ gameObject, uid }, i) => {
                    gameObject === null || gameObject === void 0 ? void 0 : gameObject.removeFromMap();
                    delete this.holes[i].gameObject;
                });
            }
        });
        this.globals.tileWorld.onMapCreated(mapName => {
            if (mapName === 'island') {
                this.holes.forEach(h => {
                    if (!h.gameObject) {
                        h.gameObject = this.initHoleGameObject(h.uid, h.x, h.y);
                    }
                });
            }
        });
    }
    getFocusedHole() {
        return this.focusedHole;
    }
    onPlayerReady() {
        this.isReady = true;
    }
    digLeftHole() {
        return this.globals.tileWorld.currentMap === 'island' && !this.possibleCollidersPreventingHole.length;
    }
    canDig() {
        return this.playerHasShovelEquipped &&
            this.digCooldown === 0 &&
            !this.$api.isInventoryOpen() &&
            !this.$api.isInDialogue() &&
            this.playerAnimation.canPlayActionAnimation();
    }
    tryingToDig() {
        var _a;
        return this.playerHasShovelEquipped && ((_a = this.playerInput) === null || _a === void 0 ? void 0 : _a.grab);
    }
    handleGameStateInitialized(gameState) {
        this.initializingFromGameState = true;
        const levelState = gameState.levels.find(l => l.name === 'island').state;
        levelState.items.forEach(i => {
            if (i.name === 'hole') {
                this.addNewHole(i.x, i.y, i.uid);
            }
        });
        this.initializingFromGameState = false;
    }
    addNewHole(x, y, uid) {
        const to = !this.initializingFromGameState ? [Constants_1.SYSTEMS.GAME_STATE, Constants_1.SYSTEMS.FLOWER] : [Constants_1.SYSTEMS.FLOWER];
        const hole = { x, y, uid };
        if (this.globals.tileWorld.currentMap === 'island') {
            hole.gameObject = this.initHoleGameObject(uid, x, y);
            //console.error('the hole ghame object became', hole.gameObject);
        }
        this.holes.push(hole);
        this.dispatchLocal({
            type: Constants_1.MESSAGES.ADDED_HOLE,
            data: { uid, x, y, gameObject: hole.gameObject },
            to,
        });
    }
    removeHole(hole) {
        let foundHole = hole;
        let foundHoleUid;
        if (typeof hole !== 'object') {
            foundHole = this.holes.find(h => h['data'].uid === hole);
            foundHoleUid = hole;
            foundHole.removeFromMap();
            if (hole === this.focusedHole) {
                this.focusedHole = null;
            }
            this.holes = this.holes.splice(this.holes.indexOf(foundHole), 1);
        }
        else {
            foundHoleUid = foundHole.data.uid;
        }
        if (!foundHole)
            throw new Error(`Could not find hole ${hole}`);
        foundHole.removeFromMap();
        if (foundHole === this.focusedHole) {
            this.focusedHole = null;
        }
        this.dispatchLocal({
            type: Constants_1.MESSAGES.REMOVED_HOLE,
            data: foundHoleUid,
            to: [Constants_1.SYSTEMS.GAME_STATE]
        });
    }
    onLocalMessage(message) {
        var _a, _b, _c, _d;
        switch (message.type) {
            case Constants_1.MESSAGES.EQUIP_ITEM:
                const ani = this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION);
                if (message.data === 'shovel') {
                    if (this.playerHasShovelEquipped) {
                        this.playerHasShovelEquipped = false;
                        (_b = (_a = this.mountedAttachment) === null || _a === void 0 ? void 0 : _a.skeleton) === null || _b === void 0 ? void 0 : _b.unmountAttachment('shovel');
                        this.mountedAttachment = null;
                        this._isShoveling = false;
                    }
                    else {
                        setTimeout(() => {
                            var _a;
                            this.playerHasShovelEquipped = true;
                            this.dispatchLocal({
                                to: [Constants_1.SYSTEMS.INVENTORY],
                                type: Constants_1.MESSAGES.EQUIPPED_SHOVEL,
                            });
                            this.mountedAttachment = (_a = ani === null || ani === void 0 ? void 0 : ani.skeleton) === null || _a === void 0 ? void 0 : _a.mountAttachment('shovel', 'shovel');
                        }, 0);
                    }
                }
                else if (this.mountedAttachment) {
                    this.playerHasShovelEquipped = false;
                    (_d = (_c = this.mountedAttachment) === null || _c === void 0 ? void 0 : _c.skeleton) === null || _d === void 0 ? void 0 : _d.unmountAttachment('shovel');
                    this.mountedAttachment = null;
                    this._isShoveling = false;
                }
                break;
            case Constants_1.MESSAGES.GAME_STATE_INITIALIZED:
                this.handleGameStateInitialized(message.data);
                break;
            case Constants_1.MESSAGES.CLIENT_PLAYER_ENTITY_INITIALIZED:
                this.handleInitPlayer();
                break;
        }
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    onInit() {
        this.globals.tileWorld.use(this.playerHoleCollisionPlugin);
        this.globals.tileWorld.use(this.playerPreventHoleCollisionPlugin);
        this.holeTexture = this.globals.gameTextures.items.placed.hole;
        this.addApi(this.removeHole);
        this.addApi(this.shovelIsEquipped);
        this.addApi(this.getFocusedHole);
        this.addApi(this.isShoveling);
    }
    isShoveling() {
        return this._isShoveling;
    }
    update(delta) {
        if (this.digCooldown) {
            this.digCooldown = Math.max(this.digCooldown - delta, 0);
        }
        if (this.tryingToDig()) {
            if (this.canDig()) {
                //TODO: make this shovel ani
                this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION).skeleton.play('dig', null, { loop: false });
                if (this.digLeftHole()) {
                    // todo : play succesful dig
                    //this.$api.playSound('dig');
                    let { x, y } = this.$api.getAheadOfPlayerPosition();
                    switch (this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION).skeleton.direction) {
                        case 'north':
                            x -= this.holeTexture.width;
                            y -= (this.holeTexture.height - 3);
                            break;
                        case 'south':
                            x -= this.holeTexture.width;
                            y -= (this.holeTexture.height - 3);
                            break;
                        case 'west':
                            x -= (this.holeTexture.width + this.holeTexture.width / 2);
                            y -= this.holeTexture.height;
                            break;
                        case 'east':
                            y -= this.holeTexture.height;
                            x -= this.holeTexture.width / 2;
                            break;
                    }
                    this.addNewHole(x + this.holeTexture.width / 2, y + this.holeTexture.height / 2, this.$api.getUid());
                }
                else {
                    //this.$api.playSound('digclank');
                    //todo : play clank dig
                }
                this.digCooldown = .5;
            }
        }
        this.possibleCollidersPreventingHole.length = 0;
    }
}
exports.DigSystem = DigSystem;
//# sourceMappingURL=module.js.map